__turbopack_context__.v({
  "arrow": "userAccountClients-module-scss-module__KOoyKG__arrow",
  "relationship": "userAccountClients-module-scss-module__KOoyKG__relationship",
  "relationshipsContainer": "userAccountClients-module-scss-module__KOoyKG__relationshipsContainer",
});
